import { render, staticRenderFns } from "./reisetermin-anlegen-modal.vue?vue&type=template&id=84b93e06&scoped=true"
import script from "./reisetermin-anlegen-modal.vue?vue&type=script&lang=js"
export * from "./reisetermin-anlegen-modal.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-anlegen-modal.vue?vue&type=style&index=0&id=84b93e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b93e06",
  null
  
)

export default component.exports